import { SystemQueryOptions, SystemQueryResponse } from "../models";
import { CursorState, ProjectId } from "../types";
import { Endpoints, getAssetsServiceBasePath } from "./constants";
import { fetchAllPaginatedResults, postWithToken } from "./helpers";

export const getSystemClient = (projectId: ProjectId) => ({
  query: async (options: SystemQueryOptions): Promise<SystemQueryResponse> => {
    const {
      includeFilters,
      fetchAll,
      limit,
      cursorState,
      includeDeleted,
      includedComputedFields,
    } = options;

    const queryAssets = (queryCursorState: CursorState) => {
      const requestBody = {
        limit: limit,
        cursorState: queryCursorState,
        query: {
          entityType: "systems_atomic_query_v1",
          includeFilters: { ...includeFilters },
          excludeFilters: {},
        },
        options: {
          ...(includeDeleted && { includeDeleted: true }),
          ...(includedComputedFields?.length && {
            includedComputedFields,
          }),
        },
      };

      return postWithToken<SystemQueryResponse>(
        `${getAssetsServiceBasePath(projectId, "v1")}/${
          Endpoints.Systems
        }:query`,
        {
          body: JSON.stringify(requestBody),
        }
      );
    };

    return fetchAll
      ? (fetchAllPaginatedResults(queryAssets) as Promise<SystemQueryResponse>)
      : queryAssets(cursorState);
  },
});
